<app-accordion title="Days" (visibleChange)="handleVisible($event)">
  <div class="header-content" header-content>
    @if (daysData) { @if (!daysData.timeline) {
    <p-skeleton width="1.5rem" height="1.5rem" />
    <p-skeleton width="1.5rem" height="1.5rem" />
    <p-skeleton width="1.5rem" height="1.5rem" />
    } @else {
    <div class="days sick">{{ daysData.sick }}</div>
    <div class="days training">{{ daysData.training }}</div>
    <div class="days days-worked">{{ daysData.daysWorked }}</div>
    } }
  </div>
  @if (visible) {
  <div class="nested-content">
    <div class="bordered-content rounded-sm">
      <div class="row-group">
        <div class="label-value col">
          <div class="multi-value">{{ daysData.timeline }}</div>
          <div>Year</div>
        </div>
        <div class="label-value col">
          <div class="days sick nested">{{ daysData.sick }}</div>
          <div>Sick</div>
        </div>
        <div class="label-value col">
          <div class="days training nested">{{ daysData.training }}</div>
          <div>Training</div>
        </div>
        <div class="label-value col">
          <div class="days days-worked nested">{{ daysData.daysWorked }}</div>
          <div>Work</div>
        </div>
      </div>
      <div class="width-100">
        @for (month of daysData.months; track $index) {
        <div class="row-group">
          <div class="label-value">
            <div class="label">{{ month.month }}</div>
            @if (month.sick === 0) {
            <div class="multi-value">-</div>
            } @else {
            <div class="multi-value">{{ month.sick }}</div>
            } @if (month.training === 0) {
            <div class="multi-value">-</div>
            } @else {
            <div class="multi-value">{{ month.training }}</div>
            } @if (month.daysWorked === 0) {
            <div class="multi-value">-</div>
            } @else {
            <div class="multi-value">{{ month.daysWorked }}</div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }
</app-accordion>
